import Model from '@/core/models/Model';
import Attribute from '@/models/Attribute';
import type { Attribute as IAttribute } from '@/types/Attribute';

class AttributeService {
  getAttributes(search: string = '') {
    return useAsyncData<IAttribute[]>(
      'attributes',
      async () => {
        const attribute = new Attribute();
        if (search) {
          attribute.where('search', search);
        }

        return Model.processResponse(await attribute.get()) as IAttribute[];
      },
      { server: false }
    );
  }
}

const service = new AttributeService();
export default service;
